import { useEffect, useRef, useState } from "react";

import styles from './styles.module.scss'
import { ModalType } from "../VersoesLiberadasContainer";

export type ActionsProps = {
    handleOption: (modalType: ModalType) => void
}

export const Actions = ({ handleOption }: ActionsProps) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            <div style={{ position: "relative", display: "inline-block" }} ref={ref}>

                <button
                    onClick={() => setOpen(o => !o)}
                    className={styles.actionsButton}
                    aria-label="Abrir menu de ações"
                    title="Mais opções"
                >
                    &#x22EE;
                </button>

                {open && (
                    <div className={styles.actionsMenu}>
                        <div
                            className={styles.actionsItem}
                             onClick={() => {
                                handleOption(ModalType.CONSULTAR_HISTORICO)
                                setOpen(false)
                            }}
                        >
                            Consultar Histórico
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}